import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
// Actions
// import { deleteLecture } from "repository/actions/data/dashboard/lectures";

export default withSnackbar(
  withRouter(function (props) {
    const {
      isOpen,
      setClose,
      itemId,
      setLectures,
      lectures,
      cohort,
      user,
      setCohort,
      editCohort,
      getCohort,
      lecturers,
      editLecture,
      deleteLecture
    } = props;
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteLecture = () => {
      if (user && user != null) {
        setSaveLoading(true);

        deleteLecture(itemId, user.idToken)
          .then((result) => {
            getCohort(cohort._id, user.idToken).then((refreshedCohort) => {
              setCohort(refreshedCohort);
              setClose();
              setSaveLoading(false);
              toast.success(`Lecture delected successfully`);
            });
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete selected lecture"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteLecture()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete this lecture?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
